import React from "react";
import { Button } from "./Button";
interface SessionExpiredDialogProps {
  onConfirm: () => void;
}

export const SessionExpiredDialog: React.FC<SessionExpiredDialogProps> = ({
  onConfirm,
}) => {
  return (
    <div
      className="fixed inset-0  flex items-center justify-center bg-auto bg-opacity-50 backdrop-blur-sm
     z-50000    "
      style={{ isolation: "isolate" }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className="bg-bg rounded-lg shadow-2xl max-w-md mx-4 overflow-hidden relative"
        style={{
          width: "400px",
          zIndex: 50001,
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="px-6 py-4  ">
          <div className="flex items-center gap-3">
            <h3
              className="text-fg font-semibold"
              style={{
                fontSize: "16px",
                fontFamily: "var(--font-sans)",
                fontWeight: "var(--font-weight-semibold)",
              }}
            >
              Session Expired
            </h3>
          </div>
        </div>

        <div className="px-6 py-4">
          <p
            className="text-fg-muted"
            style={{
              fontSize: "14px",
              lineHeight: "1.5",
              fontFamily: "var(--font-sans)",
              fontWeight: "var(--font-weight-regular)",
            }}
          >
            Your session has expired. Please log in again to continue.
          </p>
        </div>

        <div className="px-6 py-4 bg-bg-subtle flex justify-end">
          <Button onClick={onConfirm} variant="secondary" size="md">
            OK
          </Button>
        </div>
      </div>
    </div>
  );
};
